import React from 'react';
import PDVApp from './components/PDVApp';

const App = () => {
  return (
    <div>
      <PDVApp />
    </div>
  );
};

export default App;
